/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { $createLinkNode } from "@lexical/link";
import { $createListItemNode, $createListNode } from "@lexical/list";
import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { $createHeadingNode, $createQuoteNode } from "@lexical/rich-text";
import { $createParagraphNode, $createTextNode, $getRoot } from "lexical";
import * as React from "react";
import "./styles.css";

import { isDevPlayground } from "./appSettings";
import { SettingsContext, useSettings } from "./context/SettingsContext";
import { SharedAutocompleteContext } from "./context/SharedAutocompleteContext";
import { SharedHistoryContext } from "./context/SharedHistoryContext";
import Editor from "./Editor";

import PlaygroundNodes from "./nodes/PlaygroundNodes";
import DocsPlugin from "./plugins/DocsPlugin";
import PasteLogPlugin from "./plugins/PasteLogPlugin";
import { TableContext } from "./plugins/TablePlugin";
import TestRecorderPlugin from "./plugins/TestRecorderPlugin";
import TypingPerfPlugin from "./plugins/TypingPerfPlugin";
import Settings from "./Settings";
import PlaygroundEditorTheme from "./themes/PlaygroundEditorTheme";
import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin";
import type { EditorState, LexicalEditor } from "lexical";

function App(props): JSX.Element {
  const { exibirConteudo, itemIdSave, snackActiveSucess, socket, setValorItemSave } = props;
  const [mudancaTexto, setMudancaTexto] = React.useState(false);
  const [primeiraAtualizacao, setPrimeiraAtualizacao] = React.useState(true);

  //Conteúdo/Texto
  const loadContent = exibirConteudo;

  const initialEditorState = JSON.stringify(loadContent.editorState);

  const handleMudancaTexto = (editorState, _, __) => {
    if (!primeiraAtualizacao) {
      setMudancaTexto(true);
      
    } else {
      setPrimeiraAtualizacao(false);
    }
  };
  const handleMudancaTextoFalse = () => {
    setMudancaTexto(false);
    setValorItemSave(false);
  };

  const {
    settings: { isCollab, emptyEditor, measureTypingPerf },
  } = useSettings();

  const initialConfig = {
    /*editorState: isCollab
      ? null
      : emptyEditor
      ? undefined
      : prepopulatedRichText,*/
    editorState: initialEditorState ? initialEditorState : null,
    namespace: "Playground",
    nodes: [...PlaygroundNodes],
    onError: (error: Error) => {
      throw error;
    },
    theme: PlaygroundEditorTheme,
  };

  /*React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [initialConfig]);*/

  return (
    <LexicalComposer initialConfig={initialConfig}>
      <OnChangePlugin
        ignoreHistoryMergeTagChange={false}
        ignoreSelectionChange={true}
        onChange={handleMudancaTexto}
      />
      <SharedHistoryContext>
        <TableContext>
          <SharedAutocompleteContext>
            <div className="editor-shell">
              <Editor
                socket={socket}
                itemIdSave={itemIdSave}
                mudancaTexto={mudancaTexto}
                handleMudancaTextoFalse={handleMudancaTextoFalse}
                setValorItemSave={setValorItemSave}
                snackActiveSucess={snackActiveSucess}
              />
            </div>
            <Settings />
            {/* {isDevPlayground ? <DocsPlugin /> : null}
            {isDevPlayground ? <PasteLogPlugin /> : null}
            {isDevPlayground ? <TestRecorderPlugin /> : null} */}

            {measureTypingPerf ? <TypingPerfPlugin /> : null}
          </SharedAutocompleteContext>
        </TableContext>
      </SharedHistoryContext>
    </LexicalComposer>
  );
}

export default function PlaygroundApp(props): JSX.Element {
  const { exibirConteudo, itemIdSave, snackActiveSucess, socket, setValorItemSave } = props;

  return (
    <SettingsContext>
      <App
        socket={socket}
        exibirConteudo={exibirConteudo}
        itemIdSave={itemIdSave}
        setValorItemSave={setValorItemSave}
        snackActiveSucess={snackActiveSucess}
      />
    </SettingsContext>
  );
}
